import $ from 'jquery';
import 'slick-carousel';

export function imageCarousel() {
    const uniqueSlide = document.querySelectorAll(
        '*[id^="news-post__image-carousel-slider-container-"]'
    );

    uniqueSlide.forEach((item) => {
        $(item)
            .children('.news-post__image-carousel')
            .on(
                'init reInit afterChange',
                function (event, slick, currentSlide, nextSlide) {
                    let i = (currentSlide ? currentSlide : 0) + 1;
                    $(item)
                        .children('.news-post__image-carousel-paging')
                        .children('.current')
                        .text(i);
                    $(item)
                        .children('.news-post__image-carousel-paging')
                        .children('.amount')
                        .text(slick.slideCount);
                }
            );

        $(item)
            .children('.news-post__image-carousel')
            .slick({
                swipe: true,
                slidesToShow: 1,
                dots: false,
                infinite: false,
                lazyLoad: 'progressive',
                nextArrow: $(item)
                    .children()
                    .children('.news-post__image-carousel-slider-next'),
                prevArrow: $(item)
                    .children()
                    .children('.news-post__image-carousel-slider-prev'),
            });
    });
}
